import React, { useMemo } from 'react';
import {
    BroadcastViewership as BroadcastViewerShipType,
    SearchParams,
} from '@app/types/api';
import { useBroadcastsViewership } from '@app/components/hooks/useBroadcastsViewership';
import BroadcastViewershipBarChart from './BroadcastViewershipBarChart';
import BroadcastViewershipTable from './BroadcastViewershipTable';

//TODO: Remove this import
import '../../styles/BroadcastViewership.css';
import ErrorBoundary from '@app/ErrorBoundary';
import CrashedComponent from '@app/components/errors/CrashedComponent';

type BroadcastViewershipProps = {
    searchParams: SearchParams;
    client: any;
    selectedBroadcastName: string;
    setSelectedBroadcastName: (id: string) => void;
    viewershipType: string;
};

const BroadcastViewership = ({
    searchParams,
    client,
    selectedBroadcastName,
    setSelectedBroadcastName,
    viewershipType,
}: BroadcastViewershipProps) => {
    const pagination = {
        perPage: 100,
    };
    const {
        isFetching,
        data: broadcasts,
        hasNextPage,
        fetchNextPage,
    } = useBroadcastsViewership(client.id, searchParams, pagination, client);

    const mappedBroadcasts: BroadcastViewerShipType[] = useMemo(() => {
        if (!broadcasts) {
            return [];
        }
        if (Array.isArray(broadcasts)) {
            const resp: BroadcastViewerShipType[] = broadcasts;
            return resp;
        }
        const resp: BroadcastViewerShipType[] = broadcasts.pages.flatMap(
            (e: BroadcastViewerShipType) => e,
        );
        return resp;
    }, [broadcasts]);

    return (
        <ErrorBoundary FallbackComponent={CrashedComponent}>
            <div>
                <>
                    <BroadcastViewershipBarChart
                        broadcasts={mappedBroadcasts}
                        selectedBroadcastName={selectedBroadcastName}
                        setSelectedBroadcastName={setSelectedBroadcastName}
                        onLoadMore={fetchNextPage}
                        hasNextPage={hasNextPage}
                        loading={isFetching}
                        viewershipType={viewershipType}
                    />
                    <BroadcastViewershipTable
                        broadcasts={mappedBroadcasts}
                        client={client}
                        selectedBroadcastName={selectedBroadcastName}
                        loading={isFetching}
                        viewershipType={viewershipType}
                    />
                </>
            </div>
        </ErrorBoundary>
    );
};

export default BroadcastViewership;
